import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
import { getLogoSrc } from './Logo';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#0B1412]" data-id="element-786" data-mp="32o48q3wk3w3d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-787" data-mp="36oxzr65apr0h">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-788" data-mp="36n3dnoiafsut">
          <div className="md:col-span-2" data-id="element-789" data-mp="3ud7h9vvh7slt">
            <Link to="/" className="inline-block mb-4" data-id="element-790" data-mp="38zaivynj750">
              {/* Footer uses the same wordmark as the navbar, recolored to brand
                  green. The artwork is used as a CSS mask so the green fills its
                  exact shape — an <img> can't be tinted, only inverted. */}
              <span role="img" aria-label="206Gravel" className="block h-10 w-40" style={{
              backgroundColor: '#04A05C',
              WebkitMaskImage: `url(${getLogoSrc(undefined, 'light')})`,
              maskImage: `url(${getLogoSrc(undefined, 'light')})`,
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskPosition: 'left center',
              maskPosition: 'left center',
              WebkitMaskSize: 'contain',
              maskSize: 'contain'
            }} data-id="element-791" data-mp="29yxcjbkkrila" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-792" data-mp="3qazp90ge3ltk">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-793" data-mp="335s7ezi7fff">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-794" data-mp="33nlq3us7fjn">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-795" data-mp="huo4b1p8spti">
              <li data-id="element-796" data-mp="cuikg7p7s7lz">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-797" data-mp="cw34329zq652">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-798" data-mp="mt7vbgip0rsq">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-799" data-mp="mptp1x6wryg0">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-800" data-mp="yuza1tlzh7k9">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-801" data-mp="13t0v2k2yzgyd">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-802" data-mp="13s97nwjj0pj6">
              Products
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-803" data-mp="18lk7vetu2824">
              <li data-id="element-804" data-mp="1cmdv05zgbity"><Link to="/?category=Base%20%26%20Compaction#materials" className="hover:text-white/70 transition-colors" data-id="element-805" data-mp="1ckknypkxewlf">Base &amp; Compaction</Link></li>
              <li data-id="element-806" data-mp="1hmigkaf7v3r1"><Link to="/?category=Clear%20%26%20Drain#materials" className="hover:text-white/70 transition-colors" data-id="element-807" data-mp="1hmibvx49ufkp">Clear &amp; Drain</Link></li>
              <li data-id="element-808" data-mp="1rhtw2uyg8ezu"><Link to="/?category=Soil%2C%20Mulch%20%26%20Org.#materials" className="hover:text-white/70 transition-colors" data-id="element-809" data-mp="1rhtrehni7qti">Soil, Mulch &amp; Org.</Link></li>
              <li data-id="element-810" data-mp="3ta86l8ynyh68"><Link to="/?category=Quarry%20Rock#materials" className="hover:text-white/70 transition-colors" data-id="element-811" data-mp="3t9yi5pt9oi2n">Quarry Rock</Link></li>
              <li data-id="element-812" data-mp="2ag5d6l9xj2e0"><Link to="/?category=Landscape%20%26%20Decor#materials" className="hover:text-white/70 transition-colors" data-id="element-813" data-mp="2afx2n01a495z">Landscape &amp; Decor</Link></li>
            </ul>
          </div>

          <div data-id="element-814" data-mp="21m0krxf5diwd">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-815" data-mp="21nlexlxjuztp">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-816" data-mp="1wlm985ec7qtl">
              <li data-id="element-817" data-mp="2tcoewpielo0j">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-818" data-mp="2tbvjgkowakxp">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-819" data-mp="2kc01nx0u3rop">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-820" data-mp="2kbgm2mynpfdu">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-821" data-mp="18yxlh32nd452">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-822" data-mp="18zfsmuqul2rr">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-823" data-mp="2ruxzubsi9uw5">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-824" data-mp="2rug55jlhroqc">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-825" data-mp="2iw456qyqjel8">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-826" data-mp="2iwmase7af55t">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-827" data-mp="3bjgrr14wbmej">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-828" data-mp="3bl1nuv6uzdei">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-829" data-mp="31l0z2tq8052x">
          <p data-id="element-830" data-mp="36mqeelkh74wt">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-831" data-mp="1q8gm5gd44w0p">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-832" data-mp="1v6i6e4m9z1dr">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-833" data-mp="1no263j07a4a0">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-834" data-mp="1wn5oslvgghnz">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#000000]" data-id="element-835" data-mp="zy7v76zfypse">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide bg-[#000000]" data-id="element-836" data-mp="1dobcrkndlvbi">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[700] text-[#57534e]" data-id="element-837" data-mp="l5nyao2vxeje">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-838" data-mp="2gbf5hhe1vssn">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-839" data-mp="2q0ox6w4zf9g8">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors shrink-0 text-[12px] font-[700] text-[#57534e]" data-id="element-840" data-mp="2v1cnffldzm9e">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}